// @ts-nocheck

import { EventEmitter } from "./xhr-hook-misc/xhr-hook-event-emitter";
import headers from "./xhr-hook-misc/xhr-hook-headers";

//patchable types
import XMLHttpRequest from "./xhr-hook-patch/xhr-hook-xmlhttprequest";
import fetch from "./xhr-hook-patch/xhr-hook-fetch";

//global state
import hooks from "./xhr-hook-misc/xhr-hook-hooks";
//the global hooks event emitter is also the global xhook object
//(not the best decision in hindsight)
const xhook = hooks;

xhook.EventEmitter = EventEmitter;

//modify hooks
xhook.before = function (handler, i: number) {
  if (handler.length < 1 || handler.length > 2) {
    throw "invalid hook";
  }
  return xhook.on("before", handler, i);
};

xhook.after = function (handler, i) {
  if (handler.length < 2 || handler.length > 3) {
    throw "invalid hook";
  }
  return xhook.on("after", handler, i);
};

//globally enable/disable
xhook.enable = function ({ ignoreUrls }: { ignoreUrls: string[] }) {
  XMLHttpRequest.patch();
  fetch.patch({ ignoreUrls });
};

xhook.disable = function () {
  XMLHttpRequest.unpatch();
  fetch.unpatch();
};

//expose native objects
xhook.XMLHttpRequest = XMLHttpRequest.Native;
xhook.fetch = fetch.Native;

//expose helpers
xhook.headers = headers.convert;

export function xhrHookEnable({ ignoreUrls }: { ignoreUrls: string[] }): void {
  xhook.enable({ ignoreUrls });
}

export function xhrHookGetInstance() {
  return xhook;
}
